import React, { FC } from 'react'
import { IonApp, isPlatform, setupIonicReact } from '@ionic/react'
import { Mobile } from './Mobile'

import { Desktop } from './Desktop'
import { DefaultTheme, ThemeProvider } from 'styled-components'
import { AppStyles } from './App.styles'
import { ResizeProvider, ToastProvider } from '@src/components/Providers'
import { ConfigProvider, App as AntdApp } from 'antd'

export interface AppProps {
  theme: DefaultTheme
}

setupIonicReact()

export const App: FC<AppProps> = ({ theme }) => (
  <ConfigProvider theme={{ token: { colorPrimary: theme.global.brandColor, fontFamily: 'PT Sans' } }}>
    <AntdApp>
      <ThemeProvider theme={theme}>
        <AppStyles />
        <ResizeProvider>
          <ToastProvider>
            <IonApp>{isPlatform('hybrid') ? <Mobile /> : <Desktop />}</IonApp>
          </ToastProvider>
        </ResizeProvider>
      </ThemeProvider>
    </AntdApp>
  </ConfigProvider>
)
